




















































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import MoneyInput from "@/components/MoneyInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import api from "@/modules/generalLedger/services/api";
import {
  BookingTemplateItem,
  BookingTemplateListItem,
} from "@/modules/generalLedger/models/BookingTemplate";
import { t } from "@/plugins/i18n";

interface Data {
  open: boolean;
  templates: BookingTemplateListItem[];
  selectedTemplateId: number;
  previewItems: BookingTemplateItem[];
  total: number;
  copyAccEvent: boolean;
  copyInvNo: boolean;
}

interface Methods {
  loadTemplates(): Promise<void>;
  loadPreview(): Promise<void>;
  computedTotal(rate: number): string;
  load(): Promise<void>;
  goToTemplates(): void;
}

interface Computed {
  canLoad: boolean;
}

interface Props {
  transId: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "BookingTemplateLoadDialog",

  components: {
    MoneyInput,
    CheckBox,
  },

  props: {
    transId: { type: Number, default: 0 },
  },

  data(): Data {
    return {
      open: false,
      templates: [],
      selectedTemplateId: 0,
      previewItems: [],
      total: 0,
      copyAccEvent: true, // K2D dw_2 initial '+'
      copyInvNo: true, // K2D dw_2 initial '+'
    };
  },

  computed: {
    canLoad(): boolean {
      // A backend a 0 összeget elutasítja (a K2D megerősítés-utáni 0-t tudatosan nem vettük át).
      return this.selectedTemplateId > 1 && this.total !== 0;
    },
  },

  watch: {
    async open(isOpen: boolean) {
      if (!isOpen) return;
      this.total = 0;
      this.copyAccEvent = true;
      this.copyInvNo = true;
      await this.loadTemplates();
    },
  },

  methods: {
    goToTemplates() {
      this.open = false;
      this.$router.push(this.selectedTemplateId > 1
        ? `/booking-templates/edit/${this.selectedTemplateId}`
        : "/booking-templates");
    },
    async loadTemplates() {
      try {
        this.templates = await api.GetBookingTemplates();
        // K2D: az első sablon automatikusan kijelölve.
        if (!this.templates.some((t) => t.id === this.selectedTemplateId)) {
          this.selectedTemplateId = this.templates[0]?.id ?? 0;
          await this.loadPreview();
        }
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("Transactions_ASablonokBetolteseNemSikerult"));
      }
    },

    async loadPreview() {
      this.previewItems = [];
      if (this.selectedTemplateId <= 1) return;
      try {
        const template = await api.GetBookingTemplate(this.selectedTemplateId);
        this.previewItems = template.items;
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("ASablonTeteleinekBetolteseNemSikerult"));
      }
    },

    computedTotal(rate: number): string {
      return (Math.round(rate * this.total * 100) / 100).toLocaleString("hu-HU");
    },

    async load() {
      try {
        const result = await api.LoadBookingTemplate({
          templateId: this.selectedTemplateId,
          transId: this.transId,
          total: this.total,
          copyAccEvent: this.copyAccEvent,
          copyInvNo: this.copyInvNo,
        });
        if (!result.success) {
          // Több soros (felsorolásos) év-fordítási hibaüzenet is jöhet - az ErrorHandler pre-line-nal rendereli.
          eventBus.$emit("error", result.message);
          return;
        }
        eventBus.$emit("success", result.message);
        this.open = false;
        this.$emit("loaded");
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", t("Transactions_ASablonBetolteseNemSikerult"));
      }
    },
  },
});
